module.exports = __webpack_public_path__ + "img/family-at-airport.2115d4ba.jpeg";